/**
 * The purpose of this module is to translate key codes into a readable character sequence.
 *
 */

var KeyCode = (function()
{

    function toString()
    {

        function _toString(keyCode)
        {
            switch(keyCode) {
                case 8:
                    return 'backspace';
                case 9:
                    return 'tab';
                case 13:
                    return 'enter';
                case 16:
                    return 'shift';
                case 18:
                    return 'alt';
                case 27:
                    return 'escape';
                case 32:
                    return 'space';
                case 46:
                    return 'delete';
                case 187:
                    return 'plus';
                case 189:
                    return 'minus';
                case 37:
                    return 'left';
                case 38:
                    return 'up';
                case 39:
                    return 'right';
                case 40:
                    return 'down';
                default:
                    return String.fromCharCode(keyCode).toLowerCase();
            }
        }

        var strings = [];
        for (var i = 0; i < arguments.length; i++) {
            strings.push(_toString(arguments[i]));
        }

        var string = strings.join('+');

        // console.log('keyCode: ' + string);

        return string;
    }

    return {
        toString: toString
    };

})();

module.exports.KeyCode = KeyCode;
